export default "__VITE_ASSET__vIfA5llHCki2L2hJqsybqg__"